import { useCheckRoleAccess } from 'infrastructure/hooks';

import { Marquee } from '.';

import type { FC } from 'react';

interface ReadOnlyMarqueeProps {}

const ReadOnlyMarquee: FC<ReadOnlyMarqueeProps> = () => {
  const { isReadOnlyRole } = useCheckRoleAccess();

  if (isReadOnlyRole) return <Marquee text="Read Only Mode" />;

  return null;
};
export default ReadOnlyMarquee;
